module.exports = __webpack_public_path__ + "media/images/wendys-full-logo-5efbafbf390b27127affd90107f5657a.png";